import { AnnounceMode } from '../components/ClinAnnounceBar/ClinAnnounceBar'

/** How an announcement is shown: the full-width bar (default) or a page toast. */
export enum AnnouncePresentation {
  Bar = 'Bar',
  Toast = 'Toast'
}

/** A link-style action shown in a page toast, e.g. "Open screening forms". */
export interface IAnnouncementAction {
  label: string
  onClick: () => void
}

export interface IAnnouncement {
  mode: AnnounceMode
  description?: string
  title?: string
  clearOnNavigationFlag?: boolean
  presentation?: AnnouncePresentation
  action?: IAnnouncementAction
}
